<template>
  <div>
    <v-container fluid :style="{ 'min-height': '800px' }">
      <v-container class="contain-width">

        <v-row>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
              lg="6"
              offset-lg="3"
          >
            <h1 class="mt-6 mb-6">{{ $t('headings.Terms and Conditions') }}</h1>
            <TermsContent/>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import TermsContent from "./TermsContent";
import Footer from "./Footer.vue"
import {i18n} from "../i18n";
import {mapState} from "vuex";

export default {
  name: "Terms",
  metaInfo() {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Terms and Conditions'),
      htmlAttrs: {
        lang: i18n.locale
      }
    }
  },
  components: {
    TermsContent,
    Footer
  },
  computed: {
    ...mapState({
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/hp-banner-1.jpg')
      }
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
}
</script>

<style scoped>

</style>
